import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router, RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/core/material.module';
import {
  AppNotificationsStore,
  AppNotificationsStoreStoreService,
} from 'src/app/core/services/app-notifications-store.service';
import { StorageBrowser } from 'src/app/core/services/storage.service';
import { UserService } from 'src/app/core/services/user.service';
import { RolesEnum } from 'src/app/features/tests/features/constants';
import { FormatTodayOrDatePipe } from '../../../../pipes/formatTodayOrDate.pipe';

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    FormatTodayOrDatePipe,
    RouterModule,
  ],
})
export class NotificationDialogComponent {
  notificationStore: AppNotificationsStore;
  currUser: any;
  helpText: string;
  constructor(
    public userService: UserService,
    private appNotificationsStoreStoreService: AppNotificationsStoreStoreService,
    public router: Router,
    public storageBrowser: StorageBrowser,
    public dialogRef: MatDialogRef<NotificationDialogComponent>
  ) {}

  ngOnInit() {
    this.currUser = this.userService.currentUser.getValue();
    this.appNotificationsStoreStoreService.notifications$.subscribe((res) => {
      this.notificationStore = res;
      if ( [RolesEnum.Scorer].includes(this.currUser.role)) {
        this.helpText = `${this.notificationStore.notifications.meta.totalItems} are waiting for scoring`;
      }
      if ([RolesEnum.Physician, RolesEnum.PhysicianNoSign, RolesEnum.LabManager].includes(this.currUser?.role)) {
        this.helpText = `${this.notificationStore.notifications.meta.totalItems} are waiting for clinical review`;
      }
    });
  }

  onTestClick(element: any) {
    this.dialogRef.close();
    if ([RolesEnum.Scorer].includes(this.currUser.role)) {
         this.router.navigate(['/working-area', element.id, 'graphs']);
    }
    if ([RolesEnum.Physician, RolesEnum.PhysicianNoSign, RolesEnum.LabManager].includes(this.currUser?.role)) {
         this.router.navigate(['/working-area', element.id, 'report']);
    }

  }
}
